import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';
import { LoginConstants } from 'src/environments/environment';
import { ApiService } from './api.service';
import { TransactionsService } from './transactions.service';
import { PayMent } from 'src/app/core/models/payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private baseUrl: string = apiUrl.MAXGP_HOST_DIRECT;
  constructor(
    private http: HttpClient,
    private svApi: ApiService,
    private svTransaction: TransactionsService
  ) {}
  paymentConfirmation() {}

  goToPay(precio, returnUrl) {
    this.svApi
      .loginForTransaction(LoginConstants.user, LoginConstants.password)
      .subscribe((rp) => {
        let payment: PayMent = {
          tax: LoginConstants.tax,
          amount: precio,
          amountOfTransactions: 1,
          invoiceNumber: parseInt((Math.random() * 9999999).toString()),
          paymentDesc: 'Compra de plan comercial en Inforverses.com',
          refCode: 'refCode',
          returnUrl: returnUrl,
          serviceCode: LoginConstants.achCode,
          typeOfLink: '2',
          urlLogo:
            'https://web-dev.flexipay.com.co/assets/images/logo-flexipay.png',
        };

        this.svTransaction.makeTransaction(payment, rp['token_uid']).subscribe(
          (rp) => {
            if (rp) {
              setTimeout(() => {
                window.location.replace(
                  `${apiUrl.BASE_PAY_URL}/p/gateway?fti=${rp['token']}`
                );
              }, 1000);
            }
          },
          (err) => {
            console.log(err);
          }
        );
      });
  }
}
